import axios from 'axios';
import store from './store';

let base = axios.create({
  baseURL: `${process.env.VUE_APP_DEVELOPMENT_BACKEND_BASE_URL || ''}/api/v1`,
  withCredentials: true,
});

base.interceptors.response.use(
  function (resp) {
    return resp;
  },
  function (error) {
    // Handle request abort errors gracefully (don't treat as errors)
    if (error.code === 'ECONNABORTED' || error.message === 'Request aborted') {
      // Return a resolved promise with no data instead of rejecting
      return Promise.resolve({ data: null, aborted: true });
    }

    if (error.response && error.response.status === 401) {
      // Clear user state but don't redirect - let navigation guard handle redirect
      store.commit('auth_logout', false);
    }
    return Promise.reject(error);
  }
);

export default base;
